<template>
  <div class="meta-drawer__content">
    <p class="meta-drawer__title">
      {{$t('feed.settings.metaSource.newSource.title')}}
    </p>


    <el-form
      :model="metaForm"
      ref="metaForm"
      label-width="120px"
      class="demo-ruleForm"
      v-loading="loading"
      label-position="top"
    >
      <el-form-item :label="$t('feed.settings.metaSource.newSource.form.name')" prop="network_list">
        <el-input 
                  v-if="metaItemId == null"
                  v-model="metaForm.title"
                  :rules="$t('feed.settings.metaSource.newSource.rules')"
                  :placeholder="$t('feed.settings.metaSource.newSource.form.name')"
        ></el-input>
        <p v-if="metaItemId != null">{{metaForm.title}}</p>
      </el-form-item>

        <el-button
          v-if="metaItemId == null"
          size="medium"
          type="primary"
          @click="saveMeta('metaForm')">Сохранить и продолжить</el-button>

      <el-divider></el-divider>
      <ul v-if="metaItemId != null" class="meta-source-list">
        <template v-for="(item, index) in sourcesDictionary">
          <li class="meta-source-list__item" :key="item.name">
            <div style="margin-bottom: 10px">
              <i :class="`${item.preIcon} fa-${item.icon}`"></i> {{item.name}}
            </div>
            <net-source
              :source="null"
              :sources-by-net="sourcesByNet[index]"
              :net="index"
              @setSelectedSource="setSelectedSource"
              :source-name="item.name"
            />
          </li>
        </template>
      </ul>

      <div class="user-footer">
        <el-button
          v-if="metaItemId != null"
          size="medium"
          type="primary"
          @click="saveMetaItems('metaForm')">{{$t('feed.settings.metaSource.newSource.form.addButton')}}</el-button>
        <!--el-button
          size="medium"
          @click="resetForm('metaForm')">{{$t('feed.settings.metaSource.newSource.form.cancelButton')}}</el-button-->
      </div>
    </el-form>
  </div>
</template>

<script>
  /*
    The component of adding a meta source
  */

  // components
  import notify from "../../../../../../helpers/notify";
  import { saveMetaItemApi } from "../../../../../../api/feeds";
  import NetSource from './NetSource';

  export default {
    name: 'NewMetaSource',
    props: {
      sourcesDictionary: {
        type: Object,
      },
      sourcesByNet: {
        type: Object
      },
    },
    data() {
      return {
        select: [],
        networks: [],
        loading: false,
        metaItemId: null,
        metaForm: {
          title: '',
          net: {},
        },
        selectedSource: {},
      };
    },
    methods: {
      setSelectedSource({select, net}) {
        this.selectedSource = {...this.selectedSource, ...{[net]: select.toString()}};
      },
      saveMeta(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            let params = {
              id: 0,
              thread_id: this.$route.params.threadId,
              title: this.metaForm.title,
              /*...this.selectedSource ,
              tg: '',*/
            };
            saveMetaItemApi(params).then(resp => {
              console.log("KKKKKKKKKK", resp.data.id)
              this.metaItemId = resp.data.id
              notify.call(this, this.$t('feed.settings.metaSource.newSource.notify.add'), "success");
              //this.sources.push(resp.data);
              this.loading = false;
            });

          } else {
            this.loading = false;
            notify.call(this, this.$t('feed.settings.metaSource.newSource.notify.error'), "error");
            return false;
          }
        });
      },
      saveMetaItems(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.$emit('saveNewSource', this.metaItemId,  this.selectedSource)
            this.select= [];
            this.networks= [];
            this.loading= false;
            this.metaItemId= null;
            this.metaForm.title= '';
            this.metaForm.net= {};
            this.selectedSource= {};
             this.loading = false;
          } else {
            this.loading = false;
            notify.call(this, this.$t('feed.settings.metaSource.newSource.notify.error'), "error");
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
    },
    created() {
      for (let key in this.sourcesDictionary) {
        this.metaForm.net[key] = '';
      }
    },
    components: {
      NetSource,
    },
  };
</script>

<style>
  .meta-drawer__content {
    margin: 0 15px 0 15px;
    font-family: "Roboto", "Arial", sans-serif;
  }
  .meta-drawer__title {
    padding: 0;
    margin: 0;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 14px;
    color: #5E6D82;
  }
  .meta-drawer__content .el-select, .meta-drawer__content .el-input {
    display: block;
    width: 100%;
  }
  .el-tag__close.el-icon-close{
    height: 7px;
    width: 8px;
    line-height: 5px;
  }
</style>
